<template>
  <b-overlay>
    <b-card class="rounded-lg">
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
          <h4 class="text-dark m-0">
            Social History
          </h4>
        </div>
      </template>
      
  
      <div class="card-body">
        <update-patient-social-history-form
          :read-only="true"
          :patient-data="patientData"
          @refresh="$emit('refresh')"
        />
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import UpdatePatientSocialHistoryForm from "@core/components/shared/admin/patient/UpdatePatientSocialHistoryForm.vue"

export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    UpdatePatientSocialHistoryForm
  },
  props: {
    patientData: {
      type: Object,
      required: true,
    },
    consultationData: {
      type: Object,
      required: true,
    },
  },
  setup() {},
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
